class ValuesMoons extends PIXI.Container {
  constructor() {
    super();

    gameController.reelData = [];

    messageBus.subscribe(
      "spinner:GameConfigEvent",
      this.onGameConfigEvent.bind(this)
    );

    this.culmiativeCoinAmount = 0;

    this.movedCoinValues = [];
    this.valueOverlays = [];
    this.movedFrenzyValues = [];
    this.movedFrenzyValues = [];
    this.offsets = undefined;
    this.valuesOnTopFS = [];
    this.valuesOnToSC = [];
  }

  initialise() {
    const self = this;
    let index = 0;
    for (let reel = 0; reel < gameData.numReels; reel++) {
      for (let row = 0; row < gameData.numRows; row++) {
        const orginSymX = gameController.reelData[reel].position.x;
        const orginSymY =
          gameController.reelData[reel].position.y +
          gameController.reelData[reel]._symbolSpacing * row;
        const slotCell = reel * gameData.numRows + row;

        let moonContainer = resourceManager.createObject(
          "container",
          `moonContainer${slotCell}`,
          this,
          {
            x: orginSymX,
            y: orginSymY,
          }
        );

        let moonMovie = resourceManager.createObject(
          "movie",
          `moonMovie${slotCell}`,
          moonContainer,
          {
            x: 0,
            y: 0,
            definition: "Symbol_Moon_Spin",
            anchor: 0.5,
            loop: true,
          }
        );

        moonMovie.visible = false;
        moonMovie.gotoAndStop(0);

        let moonValue1 = resourceManager.createObject(
          "sprite",
          `moonValueOverlay1`,
          moonContainer,
          {
            fileName: "slots/symbols/Moon/Freespins1.png",
            anchor: 0.5,
          }
        );
        let moonValue2 = resourceManager.createObject(
          "sprite",
          `moonValueOverlay2`,
          moonContainer,
          {
            fileName: "slots/symbols/Moon/Freespins2.png",
            anchor: 0.5,
          }
        );
        let moonValue3 = resourceManager.createObject(
          "sprite",
          `moonValueOverlay3`,
          moonContainer,
          {
            fileName: "slots/symbols/Moon/Freespins3.png",
            anchor: 0.5,
          }
        );
        let moonValue4 = resourceManager.createObject(
          "sprite",
          `moonValueOverlay4`,
          moonContainer,
          {
            fileName: "slots/symbols/Moon/Freespins4.png",
            anchor: 0.5,
          }
        );

        moonValue1.visible = false;
        moonValue2.visible = false;
        moonValue3.visible = false;
        moonValue4.visible = false;

        this.valueOverlays.push({
          moonContainer: moonContainer,
          moonValue1: moonValue1,
          moonValue2: moonValue2,
          moonValue3: moonValue3,
          moonValue4: moonValue4,
          reel: reel,
          row: row,
          moonMovie: moonMovie,
          originalPosition: { x: orginSymX, y: orginSymY },
        });
        index++;
      }
    }
    this.removeAllChildren();
    Reflex.registerEventHandler("orientationChange", self.onOrientationChange);
  }

  onOrientationChange() {}

  removeAllChildren() {
    for (let i = 0; i < this.valueOverlays.length; i++) {
      this.removeChild(this.valueOverlays[i].moonContainer);
    }
  }

  addOrRemoveMoonContainer(show, slotCell) {
    if (show) {
      this.addChild(this.valueOverlays[slotCell].moonContainer);
    } else {
      this.removeChild(this.valueOverlays[slotCell].moonContainer);
    }
  }

  animateMoonValue(slotCell) {
    let originalY = this.valueOverlays[slotCell].moonContainer.y;
    if (gameController.slamStopped) {
      this.valueOverlays[slotCell].moonContainer.y = originalY;
    } else {
      gsap
        .timeline()
        .to(this.valueOverlays[slotCell].moonContainer, {
          duration: 0.1,
          y: this.valueOverlays[slotCell].moonContainer.y + 20,
          ease: "power1.out",
        })
        .to(this.valueOverlays[slotCell].moonContainer, {
          duration: 0.1,
          y: this.valueOverlays[slotCell].moonContainer.y - 15,
          ease: "power1.in",
        })
        .to(this.valueOverlays[slotCell].moonContainer, {
          duration: 0.1,
          y: this.valueOverlays[slotCell].moonContainer.y + 5,
          ease: "power1.out",
        })
        .to(this.valueOverlays[slotCell].moonContainer, {
          duration: 0.1,
          y: this.valueOverlays[slotCell].moonContainer.y - 10,
          ease: "power1.in",
        })
        .to(this.valueOverlays[slotCell].moonContainer, {
          duration: 0.1,
          y: this.valueOverlays[slotCell].moonContainer.y + 3,
          ease: "power1.out",
          onComplete: () => {
            this.valueOverlays[slotCell].moonContainer.y = originalY;
          },
        });
    }
  }

  playMoonMovie(slotCell, show) {
    if (show) {
      this.valueOverlays[slotCell].moonMovie.visible = true;
      this.valueOverlays[slotCell].moonMovie.gotoAndPlay(0);
    } else {
      this.valueOverlays[slotCell].moonMovie.visible = false;
      this.valueOverlays[slotCell].moonMovie.gotoAndStop(0);
    }
  }

  showMoonValue(show, slotCell, numberOfSpins) {
    this.addOrRemoveMoonContainer(show, slotCell);
    this.valueOverlays[slotCell][`moonValue${numberOfSpins}`].visible = show;
  }

  hideAllMoonValues(slotCell) {
    for (let i = 1; i < 5; i++) {
      if (this.valueOverlays[slotCell][`spinMoonValue${i}`]) {
        this.valueOverlays[slotCell][`spinMoonValue${i}`].visible = false;
        this.valueOverlays[slotCell][`moonValue${i}`].visible = false;
      }
    }
  }

  onGameConfigEvent() {
    this.initialise();
  }
}

var valuesMoonsDisplayCreator = function (json) {
  return new ValuesMoons();
};

var valuesMoonsDisplayInitialiser = function (json, buggy) {};

var valuesMoonsDisplayFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "ValuesMoons",
  valuesMoonsDisplayCreator,
  valuesMoonsDisplayInitialiser,
  valuesMoonsDisplayFilesRequired
);
